import React from 'react';
import { Database, FileText } from 'lucide-react';
import { cn } from '@/lib/utils';
import type { CollectionReferenceIds } from '@/utils/collection-references';
import {
  referenceDisplayName,
  referenceKey,
} from '@/utils/collection-references';

interface CollectionChipsProps {
  references: CollectionReferenceIds[];
  names: ReadonlyMap<string, string>;
  className?: string;
}

export const CollectionChips: React.FC<CollectionChipsProps> = ({
  references,
  names,
  className,
}) => {
  if (references.length === 0) return null;

  return (
    <div className={cn('flex w-full flex-col items-end gap-1', className)}>
      {references.map((reference) => {
        const Icon = reference.kind === 'dataset' ? Database : FileText;
        return (
          <span
            key={referenceKey(reference)}
            className='flex max-w-[85%] items-center gap-1.5 rounded-2xl bg-zinc-100 px-3 py-1.5 text-xs text-zinc-700 dark:bg-zinc-800 dark:text-zinc-200'
          >
            <Icon className='size-3.5 shrink-0 text-muted-foreground' />
            <span className='truncate'>
              {referenceDisplayName(reference, names)}
            </span>
          </span>
        );
      })}
    </div>
  );
};
